import { FC } from 'react'
import {
  AnotacaoType,
  IconPaths,
  KTSVG,
  SituacaoInterconsulta,
} from '../../../../../../../_metronic/helpers'
import { AtendimentoView } from '../../../../atendimento/core/_models'

type Props = {
  atendimento: AtendimentoView | undefined
  className?: string
}

/**
 * Réplicas do solicitante de uma interconsulta (anotações `REPLICA`), com destaque quando há uma em
 * aberto — é o texto que o teleconsultor precisa ler para responder no novo parecer. Aparece no modal
 * da fila e dentro da tela do atendimento; sem réplica não renderiza nada.
 */
export const ReplicasSolicitante: FC<Props> = ({ atendimento, className }) => {
  const replicas = atendimento?.anotacoes?.filter(
    (anotacao) => anotacao.tipo === AnotacaoType.Replica
  )
  if (!replicas?.length) return null

  const emAberto = atendimento?.situacaoInterconsulta === SituacaoInterconsulta.EmReplica

  return (
    <div className={`atd-alert atd-alert-info ${className ?? ''}`}>
      <div className='atd-alert-title'>
        <KTSVG path={IconPaths.Info} className='svg-icon-2 svg-icon-info' />
        {emAberto
          ? 'Réplica do solicitante · responda em um novo parecer'
          : 'Réplicas do solicitante'}
      </div>
      {replicas.map((anotacao, index) => (
        <div className='atd-alert-entry' key={anotacao.id ?? index}>
          <div className='atd-alert-meta'>
            {anotacao.dataFormatada} — {anotacao.usuario?.nome}
          </div>
          <div className='atd-alert-body'>{anotacao.anotacao}</div>
        </div>
      ))}
    </div>
  )
}

export const temReplica = (atendimento: AtendimentoView | undefined) =>
  atendimento?.anotacoes?.some((anotacao) => anotacao.tipo === AnotacaoType.Replica) ?? false
